
<Modal modalType="ImageExport" mayCancel="true" v-on:cancel="onCancel">
  <h2>Save Image</h2>
  <form class="SaveImage_Form PForm" v-on:click.stop novalidate>
    <p class="SaveImage_Form_Section">
      <label class="m-inline" for="transparentBackground"
        >Transparent background</label
      >
      <input
        v-model="transparentBackground"
        type="checkbox"
        id="transparentBackground"
      />
    </p>
    <p class="SaveImage_Form_Section">
      <label class="m-inline" for="scaleFactor">Scale factor</label>
      <input
        v-model="scaleFactor"
        type="number"
        min="0.01"
        step="0.5"
        id="scaleFactor"
      />
    </p>
    <p>Size: {{ computedSize.x }}x{{ computedSize.y }}</p>
    <p class="InlineWarning" v-if="sizeWarning">
      At this size, your export will take several minutes.
    </p>
    <p v-if="sizeWarning">
      <button class="WBMBigButton" v-on:click.prevent="onMakeSmaller">
        Shrink to biggest size that exports quickly
      </button>
    </p>
  </form>
  <div class="ButtonRow-FlexSpaceBetween" v-if="progress !== null">
    <progress :value="progress" max="1">
      {{ Math.round(progress * 100) }}%
    </progress>
  </div>
  <div class="ButtonRow-FlexSpaceBetween">
    <button class="WBMBigButton" v-on:click="onCancel">Cancel</button>
    <button class="WBMBigButton m-primary" ref="downloadButton">
      Download
    </button>
  </div>
</Modal>
